module.exports = {
  colors: {
    core: {
      'whl-colour-core-01': '#DB0011',
      'whl-colour-core-02': '#000000',
      'whl-colour-core-03': '#FFFFFF',
    },
    reds: {
      'whl-colour-red-10': '#F9F2F3',
      'whl-colour-red-60': '#DB0011',
      'whl-colour-red-70': '#AF000D',
      'whl-colour-red-80': '#A8000B',
      'whl-colour-red-90': '#83000A',
    },
    greys: {
      'whl-colour-grey-05': '#F3F3F3',
      'whl-colour-grey-10': '#EDEDED',
      'whl-colour-grey-15': '#D7D8D6',
      'whl-colour-grey-55': '#767676',
      'whl-colour-grey-80': '#333333',
      'whl-colour-grey-85': '#212121',
      'whl-colour-grey-90': '#1D1D1D',
      'whl-colour-grey-95': '#101010',
    },
    'interaction-default': {
      'whl-colour-int-default-01': '#FFFFFF',
      'whl-colour-int-default-02': '#F1F3F4',
      'whl-colour-int-default-03': '#E4E8EA',
      'whl-colour-int-default-04': '#C9D0D5',
      'whl-colour-int-default-05': '#4D6474',
      'whl-colour-int-default-06': '#3E505D',
      'whl-colour-int-default-07': '#1D262C',
    },
    'interaction-defined': {
      'whl-colour-int-defined-01': '#FFFFFF',
      'whl-colour-int-defined-02': '#EBF5F5',
      'whl-colour-int-defined-03': '#D9EDEC',
      'whl-colour-int-defined-04': '#B2DAD8',
      'whl-colour-int-defined-05': '#005E59',
      'whl-colour-int-defined-06': '#004F4B',
      'whl-colour-int-defined-07': '#00847F',
    },
    blues: {
      'whl-colour-blue-10': '#EBEFF4',
      'whl-colour-blue-80': '#305A85',
    },
    greens: {
      'whl-colour-green-10': '#E5F2F2',
      'whl-colour-green-80': '#00847F',
    },
    ambers: {
      'whl-colour-amber-10': '#FFF8EA',
      'whl-colour-amber-80': '#FFBB33',
    },
    opacity: {
      'whl-opacity-00': '0%',
      'whl-opacity-08': '8%',
      'whl-opacity-20': '20%',
      'whl-opacity-80': '80%',
      'whl-opacity-100': '100%',
    },
    hover: {
      formElements: '#2278CE',
    },
  },
  fonts: {
    serif: 'UniversNextforHSBC, Arial, sans-serif',
  },
  fontSizes: {
    ts1: {
      s1: '33px',
      s2: '28px',
      s3: '23px',
      s4: '19px',
      s5: '16px',
      s6: '14px',
      s7: '12px',
    },
    ts2: {
      s1: '44px',
      s2: '35px',
      s3: '28px',
      s4: '22px',
      s5: '16px',
      s6: '14px',
      s7: '12px',
    },
    ts3: {
      s1: '57px',
      s2: '43px',
      s3: '32px',
      s4: '24px',
      s5: '16px',
      s6: '14px',
      s7: '12px',
    },
    compact: {
      s1: '26px',
      s2: '20px',
      s3: '18px',
      s4: '16px',
      s5: '14px',
      s6: '12px',
    },
  },
  lineHeights: {
    ts1: {
      s1: 1.2,
      s2: 1.3,
      s3: 1.3,
      s4: 1.4,
      s5: 1.5,
      s6: 1.4,
      s7: 1.3,
    },
    ts2: {
      s1: 1.15,
      s2: 1.2,
      s3: 1.3,
      s4: 1.4,
      s5: 1.5,
      s6: 1.4,
      s7: 1.3,
    },
    ts3: {
      s1: 1.15,
      s2: 1.2,
      s3: 1.3,
      s4: 1.3,
      s5: 1.5,
      s6: 1.4,
      s7: 1.3,
    },
    compact: {
      s1: 1.31,
      s2: 1.3,
      s3: 1.3,
      s4: 1.31,
      s5: 'normal',
      s6: 'normal',
    },
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  letterSpacings: {
    s: '0.031em',
    xs: '0.016em',
    normal: 'normal',
  },
  breakpoints: ['0px', '320px', '480px', '760px', '960px', '1280px', '1600px'],
  breakpointVariants: {
    xs: 320,
    sm: 480,
    ms: 760,
    md: 960,
    lg: 1280,
    xl: 1600,
  },
  hBreakpoints: {
    extraSmall: '320px',
    small: '480px',
    mediumSmall: '760px',
    medium: '960px',
    large: '1280px',
    extraLarge: '1600px',
  },
  vBreakpoints: {
    medium: '865px',
  },
  direction: 'ltr',
  space: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48],
  spacing: {
    rs1: {
      r0: 0,
      r1: '4px',
      r2: '8px',
      r3: '12px',
      r4: '16px',
      r5: '20px',
      r6: '24px',
      r7: '28px',
      r8: '32px',
      r9: '36px',
      r10: '40px',
      r11: '44px',
      r12: '48px',
    },
    rs2: {
      r0: '4px',
      r1: '8px',
      r2: '12px',
      r3: '16px',
      r4: '20px',
      r5: '24px',
      r6: '28px',
      r7: '32px',
      r8: '36px',
      r9: '40px',
      r10: '48px',
      r11: '52px',
      r12: '56px',
    },
    rs3: {
      r0: '8px',
      r1: '12px',
      r2: '16px',
      r3: '20px',
      r4: '24px',
      r5: '28px',
      r6: '32px',
      r7: '36px',
      r8: '40px',
      r9: '48px',
      r10: '56px',
      r11: '60px',
      r12: '64px',
    },
  },
  typography: {
    ts1: {
      variantMapping: {
        h1: {
          fontSize: '33px',
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: 'normal',
        },
        h1Light: {
          fontSize: '33px',
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: 'normal',
        },
        h2: {
          fontSize: '28px',
          fontWeight: 300,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h3: {
          fontSize: '23px',
          fontWeight: 300,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h4: {
          fontSize: '19px',
          fontWeight: 300,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        h4Title: {
          fontSize: '19px',
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body1Title: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1Light: {
          fontSize: '16px',
          fontWeight: 300,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body2Title: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2Light: {
          fontSize: '14px',
          fontWeight: 300,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body3: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        articleLarge: {
          fontSize: '17px',
          fontWeight: 400,
          lineHeight: 1.6,
          letterSpacing: 'normal',
        },
      },
    },
    ts2: {
      variantMapping: {
        h1: {
          fontSize: '44px',
          fontWeight: 300,
          lineHeight: 1.15,
          letterSpacing: 'normal',
        },
        h1Light: {
          fontSize: '44px',
          fontWeight: 300,
          lineHeight: 1.15,
          letterSpacing: 'normal',
        },
        h2: {
          fontSize: '35px',
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: 'normal',
        },
        h3: {
          fontSize: '28px',
          fontWeight: 300,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h4: {
          fontSize: '22px',
          fontWeight: 300,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        h4Title: {
          fontSize: '22px',
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body1Title: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1Light: {
          fontSize: '16px',
          fontWeight: 300,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body2Title: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2Light: {
          fontSize: '14px',
          fontWeight: 300,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body3: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        articleLarge: {
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: 1.8,
          letterSpacing: 'normal',
        },
      },
    },
    ts3: {
      variantMapping: {
        h1: {
          fontSize: '57px',
          fontWeight: 300,
          lineHeight: 1.15,
          letterSpacing: 'normal',
        },
        h1Light: {
          fontSize: '57px',
          fontWeight: 300,
          lineHeight: 1.15,
          letterSpacing: 'normal',
        },
        h2: {
          fontSize: '43px',
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: 'normal',
        },
        h3: {
          fontSize: '32px',
          fontWeight: 300,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h4: {
          fontSize: '24px',
          fontWeight: 300,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h4Title: {
          fontSize: '24px',
          fontWeight: 500,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        body1Title: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body1Light: {
          fontSize: '16px',
          fontWeight: 300,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        body2: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2Title: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body2Light: {
          fontSize: '14px',
          fontWeight: 300,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        body3: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        articleLarge: {
          fontSize: '19px',
          fontWeight: 400,
          lineHeight: 1.9,
          letterSpacing: 'normal',
        },
      },
    },
    compact: {
      variantMapping: {
        h1: {
          fontSize: '26px',
          fontWeight: 500,
          lineHeight: 1.31,
          letterSpacing: 'normal',
        },
        h1Light: {
          fontSize: '26px',
          fontWeight: 300,
          lineHeight: 1.31,
          letterSpacing: 'normal',
        },
        h2: {
          fontSize: '20px',
          fontWeight: 500,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h3: {
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: 1.3,
          letterSpacing: 'normal',
        },
        h4: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.31,
          letterSpacing: 'normal',
        },
        body1Title: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        body1: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        body2Title: {
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        body2: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
      },
    },
    links: {
      light: {
        '&:visited': {
          color: '#333333',
        },
        '&:active': {
          color: '#333333',
        },
      },
      dark: {
        '&:visited': {
          color: '#FFFFFF',
        },
        '&:active': {
          color: '#FFFFFF',
        },
      },
    },
    headings: {
      typeMapping: {
        h1: {
          as: 'h1',
        },
        h2: {
          as: 'h2',
        },
        h3: {
          as: 'h3',
        },
        h4: {
          as: 'h4',
        },
        body1: {
          as: 'span',
        },
        body2: {
          as: 'span',
        },
      },
    },
    variantMapping: {
      h1: {
        fontSize: '26px',
        fontWeight: 500,
        lineHeight: 1.31,
        letterSpacing: 'normal',
      },
      h1Light: {
        fontSize: '26px',
        fontWeight: 300,
        lineHeight: 1.31,
        letterSpacing: 'normal',
      },
      h2: {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1.3,
        letterSpacing: 'normal',
      },
      h3: {
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: 1.3,
        letterSpacing: 'normal',
      },
      h4: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1.31,
        letterSpacing: 'normal',
      },
      body1Title: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      body1: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      body2Title: {
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      body2: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      subtitle1: {},
      subtitle2: {},
      caption: {},
    },
    modeMapping: {
      light: {
        color: '#333333',
      },
      dark: {
        color: '#FFFFFF',
      },
    },
  },
  pseudoStates: {
    disabled: {
      default: {
        opacity: 0.5,
        cursor: 'not-allowed',
        touchAction: 'none',
      },
      light: {
        opacity: 0.3,
        cursor: 'not-allowed',
        touchAction: 'none',
      },
      dark: {
        opacity: 0.5,
        cursor: 'not-allowed',
        touchAction: 'none',
      },
    },
    focus: {
      boxShadow: '0 0 0 3px rgba(0, 103, 244, 0.247)',
      borderWidth: '2px',
    },
  },
  accordion: {
    accordionSummary: {
      base: {
        width: '100%',
        color: '#333333',
        backgroundColor: '#FFFFFF',
        border: 'none',
        padding: '0px',
        '&:hover': {
          backgroundColor: '#F1F3F4',
        },
        '&:active': {
          backgroundColor: '#E4E8EA',
        },
      },
      disabled: {
        color: '#333333',
        opacity: 0.3,
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:active': {
          backgroundColor: 'transparent',
        },
      },
      compact: {
        sizeMapping: {
          large: {
            minHeight: '44px',
            height: 'fit-content',
            paddingTop: '10px',
            paddingBottom: '10px',
          },
          small: {
            minHeight: '40px',
            height: 'fit-content',
            paddingTop: '9px',
            paddingBottom: '9px',
          },
        },
        fontSizeMapping: {
          large: {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: 1.31,
            letterSpacing: 'normal',
          },
          small: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
        },
        iconMapping: {
          large: {
            marginLeft: '16px',
            marginRight: '10px',
          },
          small: {
            marginLeft: '16px',
            marginRight: '8px',
          },
        },
      },
      hBreakpoints: {
        extraLarge: {
          sizeMapping: {
            large: {
              minHeight: '48px',
              height: 'fit-content',
              paddingTop: '8px',
              paddingBottom: '8px',
            },
            small: {
              minHeight: '44px',
              height: 'fit-content',
              paddingTop: '9px',
              paddingBottom: '9px',
            },
          },
          fontSizeMapping: {
            large: {
              fontSize: '22px',
              fontWeight: 300,
              lineHeight: 1.4,
              letterSpacing: 'normal',
            },
            small: {
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: 1.5,
              letterSpacing: 'normal',
            },
          },
          iconMapping: {
            large: {
              height: '48px',
              marginLeft: '16px',
              marginRight: '8px',
            },
            small: {
              height: '44px',
              marginLeft: '16px',
              marginRight: '8px',
            },
          },
        },
        medium: {
          sizeMapping: {
            large: {
              minHeight: '46px',
              height: 'fit-content',
              paddingTop: '9px',
              paddingBottom: '9px',
            },
            small: {
              minHeight: '44px',
              height: 'fit-content',
              paddingTop: '9px',
              paddingBottom: '9px',
            },
          },
          fontSizeMapping: {
            large: {
              fontSize: '19px',
              fontWeight: 300,
              lineHeight: 1.4,
              letterSpacing: 'normal',
            },
            small: {
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: 1.5,
              letterSpacing: 'normal',
            },
          },
          iconMapping: {
            large: {
              marginLeft: '16px',
              marginRight: '13px',
            },
            small: {
              marginLeft: '16px',
              marginRight: '8px',
            },
          },
        },
      },
    },
    accordionDetail: {
      compact: {
        paddingBottom: '20px',
      },
      hBreakpoints: {
        extraLarge: {
          paddingTop: '8px',
          paddingBottom: '24px',
        },
        medium: {
          paddingTop: '4px',
          paddingBottom: '20px',
        },
      },
    },
  },
  badge: {
    circle: {
      color: 'white',
      padding: '0 5px',
      height: '20px',
      minWidth: '20px',
      borderRadius: '10px',
      fontSize: '14px',
      backgroundColor: '#DB0011',
      display: 'flex',
      'place-content': 'center',
      'align-items': 'center',
      'white-space': 'nowrap',
      disable: {
        backgroundColor: '#D7D8D6',
      },
    },
    dot: {
      height: '12px',
      width: '12px',
      borderRadius: '6px',
      backgroundColor: '#DB0011',
      disable: {
        backgroundColor: '#D7D8D6',
      },
    },
    position: {
      topRight: {
        transform: 'scale(1) translate(50%, -50%)',
        top: 0,
        right: 0,
      },
      topLeft: {
        transform: 'scale(1) translate(-50%, -50%)',
        top: 0,
        left: 0,
      },
      bottomRight: {
        transform: 'scale(1) translate(50%, 50%)',
        bottom: 0,
        right: 0,
      },
      bottomLeft: {
        transform: 'scale(1) translate(-50%, 50%)',
        bottom: 0,
        left: 0,
      },
    },
  },
  buttons: {
    icon: {
      direction: {
        left: {
          marginRight: '8px',
        },
        right: {
          marginLeft: '8px',
        },
      },
      variantMapping: {
        light: {
          primary: {
            color: 'inherit',
          },
          secondary: {
            color: 'inherit',
          },
          tertiary: {
            color: 'inherit',
          },
          legacy: {
            color: 'inherit',
          },
        },
        dark: {
          primary: {
            color: 'inherit',
          },
          secondary: {
            color: 'inherit',
          },
          tertiary: {
            color: 'inherit',
          },
          legacy: {
            color: 'inherit',
          },
        },
      },
    },
    pureIcon: {
      sizeMapping: {
        small: {
          padding: '5px',
        },
        large: {
          padding: '10px',
        },
      },
    },
    loadingIcon: {
      direction: {
        left: {
          paddingRight: '10px',
        },
        right: {
          paddingLeft: '10px',
        },
      },
    },
    disabled: {
      light: {
        border: '1px solid #333333',
        color: '#333333',
        opacity: 0.3,
        backgroundColor: 'transparent',
        cursor: 'not-allowed',
        '&:hover, &.focus-visible': {
          backgroundColor: 'transparent',
          borderColor: '#333333',
        },
        '&:focus-visible': {
          backgroundColor: 'transparent',
          borderColor: '#333333',
        },
        '&:active': {
          backgroundColor: 'transparent',
          borderColor: '#333333',
        },
      },
      dark: {
        border: '1px solid #FFFFFF',
        color: '#FFFFFF',
        opacity: 0.35,
        backgroundColor: 'transparent',
        cursor: 'not-allowed',
        '&:hover, &.focus-visible': {
          backgroundColor: 'transparent',
          borderColor: '#FFFFFF',
        },
        '&:focus-visible': {
          backgroundColor: 'transparent',
          borderColor: '#FFFFFF',
        },
        '&:active': {
          backgroundColor: 'transparent',
          borderColor: '#FFFFFF',
        },
      },
    },
    variantMapping: {
      light: {
        primary: {
          backgroundColor: '#DB0011',
          borderColor: '#DB0011',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#AF000D',
            borderColor: '#AF000D',
          },
          '&:focus-visible': {
            backgroundColor: '#AF000D',
            borderColor: '#AF000D',
          },
          '&:active': {
            backgroundColor: '#83000A',
            borderColor: '#83000A',
          },
        },
        secondary: {
          backgroundColor: '#4D6474',
          borderColor: '#4D6474',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D',
          },
          '&:focus-visible': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D',
          },
          '&:active': {
            backgroundColor: '#1D262C',
            borderColor: '#1D262C',
          },
        },
        tertiary: {
          backgroundColor: '#FFFFFF',
          borderColor: '#333333',
          color: '#333333',
          '&:hover, &.focus-visible': {
            backgroundColor: '#F1F3F4',
            borderColor: '#333333',
          },
          '&:focus-visible': {
            backgroundColor: '#F1F3F4',
            borderColor: '#333333',
          },
          '&:active': {
            backgroundColor: '#E4E8EA',
            borderColor: '#333333',
          },
        },
        legacy: {
          backgroundColor: '#00847F',
          borderColor: '#00847F',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#005E59',
            borderColor: '#005E59',
          },
          '&:focus-visible': {
            backgroundColor: '#005E59',
            borderColor: '#005E59',
          },
          '&:active': {
            backgroundColor: '#004F4B',
            borderColor: '#004F4B',
          },
        },
      },
      dark: {
        primary: {
          backgroundColor: '#DB0011',
          borderColor: '#DB0011',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#AF000D',
            borderColor: '#AF000D',
          },
          '&:focus-visible': {
            backgroundColor: '#AF000D',
            borderColor: '#AF000D',
          },
          '&:active': {
            backgroundColor: '#83000A',
            borderColor: '#83000A',
          },
        },
        secondary: {
          backgroundColor: '#4D6474',
          borderColor: '#4D6474',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D',
          },
          '&:focus-visible': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D',
          },
          '&:active': {
            backgroundColor: '#1D262C',
            borderColor: '#1D262C',
          },
        },
        tertiary: {
          backgroundColor: 'transparent',
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#4D6474',
            color: '#FFFFFF',
          },
          '&:focus-visible': {
            backgroundColor: '#4D6474',
            color: '#FFFFFF',
          },
          '&:active': {
            backgroundColor: '#3E505D',
          },
        },
        legacy: {
          backgroundColor: '#00847F',
          borderColor: '#00847F',
          color: '#FFFFFF',
          '&:hover, &.focus-visible': {
            backgroundColor: '#005E59',
            borderColor: '#005E59',
          },
          '&:focus-visible': {
            backgroundColor: '#005E59',
            borderColor: '#005E59',
          },
          '&:active': {
            backgroundColor: '#004F4B',
            borderColor: '#004F4B',
          },
        },
      },
    },
    sizeMapping: {
      small: {
        fontSize: '12px',
        fontWeight: 400,
        letterSpacing: 'normal',
        paddingLeft: '14px',
        paddingRight: '14px',
        minHeight: '30px',
        height: 'fit-content',
      },
      large: {
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: 'normal',
        paddingLeft: '19px',
        paddingRight: '19px',
        minHeight: '40px',
        height: 'fit-content',
      },
    },
    hBreakpoints: {
      base: {
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: 'normal',
        minHeight: '44px',
        height: 'fit-content',
      },
      pureIcon: {
        sizeMapping: {
          small: {
            padding: '5px',
          },
          large: {
            padding: '12px',
          },
        },
      },
    },
  },
  card: {
    base: {
      backgroundColor: '#FFFFFF',
      borderWidth: '1px',
      borderColor: '#E4E8EA',
      borderBottomColor: '#C9D0D5',
      flexDirection: 'column',
    },
    section: {
      borderColor: '#E4E8EA',
    },
    compact: {
      cardSection: {
        padding: '16px 20px 20px',
      },
    },
    hBreakpoints: {
      extraLarge: {
        base: {
          padding: '16px 20px 24px',
        },
      },
      medium: {
        base: {
          padding: '12px 16px 20px',
        },
      },
    },
  },
  checkbox: {
    icon: {
      light: {
        color: '#00847F',
        fill: '#00847F',
      },
      dark: {
        color: '#00847F',
        fill: '#00847F',
      },
    },
    stateMapping: {
      invalid: {
        borderColor: '#A8000B',
        backgroundColor: '#F9F2F3',
      },
    },
    variantMapping: {
      light: {
        borderColor: '#767676',
        '&:hover': {
          borderColor: '#2278CE',
        },
      },
      dark: {
        borderColor: '#FFFFFF',
        color: '#FFFFFF',
        '&:hover': {
          borderColor: '#2278CE',
        },
      },
    },
    compact: {
      sizeMapping: {
        box: {
          small: {
            width: '20px',
            height: '20px',
          },
          large: {
            width: '30px',
            height: '30px',
          },
        },
        icon: {
          small: {
            width: '14px',
            height: '14px',
          },
          large: {
            width: '18px',
            height: '18px',
          },
        },
        iconSvgMargin: {
          small: {
            margin: '-2px',
          },
          large: {
            margin: '-4px',
          },
        },
      },
      label: {
        base: {
          color: '#333333',
          cursor: 'pointer',
        },
        right: {
          paddingLeft: '9px',
        },
        left: {
          paddingRight: '9px',
        },
      },
      iconMapping: {
        small: '14',
        large: '18',
      },
      paddingVertical: '5',
    },
    hBreakpoints: {
      sizeMapping: {
        box: {
          base: {
            width: '32px',
            height: '32px',
          },
        },
        iconSvgMargin: {
          base: {
            margin: '-4px',
          },
        },
      },
      label: {
        base: {
          color: '#333333',
          cursor: 'pointer',
        },
        right: {
          paddingLeft: '12px',
        },
        left: {
          paddingRight: '12px',
        },
      },
      iconMapping: {
        small: '18',
        large: '18',
      },
      paddingVertical: '6',
    },
  },
  links: {
    chevronLink: {
      icon: {
        variantMapping: {
          light: '#DB0011',
          dark: '#FFFFFF',
        },
      },
      compact: {
        iconSizeMapping: {
          h1: {
            width: '21px',
            height: '21px',
          },
          h2: {
            width: '17px',
            height: '17px',
          },
          h3: {
            width: '15px',
            height: '15px',
          },
          h4: {
            width: '13px',
            height: '13px',
          },
          body1: {
            width: '11px',
            height: '11px',
          },
          body1Title: {
            width: '11px',
            height: '11px',
          },
          body2: {
            width: '10px',
            height: '10px',
          },
          body2Title: {
            width: '10px',
            height: '10px',
          },
        },
        directionMapping: {
          h1: {
            left: {
              marginRight: '2px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h2: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h3: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h4: {
            left: {
              marginRight: '2px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body1: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body1Title: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body2: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body2Title: {
            left: {
              marginRight: '3px',
            },
            right: {
              marginLeft: '6px',
            },
          },
        },
        transformMapping: {
          h1: {
            transform: 'translateY(2px)',
          },
          h2: {
            transform: 'translateY(2px)',
          },
          h3: {
            transform: 'translateY(2px)',
          },
          h4: {
            transform: 'translateY(2px)',
          },
          body1: {
            transform: 'translateY(1px)',
          },
          body1Title: {
            transform: 'translateY(1px)',
          },
          body2: {
            transform: 'translateY(1px)',
          },
          body2Title: {
            transform: 'translateY(1px)',
          },
        },
      },
      hBreakpoints: {
        minExtraLarge: {
          iconSizeMapping: {
            h1: {
              width: '30px',
              height: '30px',
            },
            h2: {
              width: '23px',
              height: '23px',
            },
            h3: {
              width: '18px',
              height: '18px',
            },
            h4: {
              width: '13px',
              height: '13px',
            },
            body1: {
              width: '13px',
              height: '13px',
            },
            body2: {
              width: '12px',
              height: '12px',
            },
            body3: {
              width: '10px',
              height: '10px',
            },
          },
          directionMapping: {
            h1: {
              left: {
                marginRight: '5px',
              },
              right: {
                marginLeft: '14px',
              },
            },
            h2: {
              left: {
                marginRight: '4px',
              },
              right: {
                marginLeft: '11px',
              },
            },
            h3: {
              left: {
                marginRight: '3px',
              },
              right: {
                marginLeft: '8px',
              },
            },
            h4: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '6px',
              },
            },
            body1: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '6px',
              },
            },
            body2: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '5px',
              },
            },
            body3: {
              left: {
                marginRight: '1px',
              },
              right: {
                marginLeft: '4px',
              },
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(3px)',
            },
            h2: {
              transform: 'translateY(2px)',
            },
            h3: {
              transform: 'translateY(2px)',
            },
            h4: {
              transform: 'translateY(1px)',
            },
            body1: {
              transform: 'translateY(1px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(1px)',
            },
          },
        },
        extraLarge: {
          iconSizeMapping: {
            h1: {
              width: '24px',
              height: '24px',
            },
            h2: {
              width: '20px',
              height: '20px',
            },
            h3: {
              width: '16px',
              height: '16px',
            },
            h4: {
              width: '12px',
              height: '12px',
            },
            body1: {
              width: '13px',
              height: '13px',
            },
            body2: {
              width: '12px',
              height: '12px',
            },
            body3: {
              width: '10px',
              height: '10px',
            },
          },
          directionMapping: {
            h1: {
              left: {
                marginRight: '4px',
              },
              right: {
                marginLeft: '11px',
              },
            },
            h2: {
              left: {
                marginRight: '3px',
              },
              right: {
                marginLeft: '9px',
              },
            },
            h3: {
              left: {
                marginRight: '3px',
              },
              right: {
                marginLeft: '7px',
              },
            },
            h4: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '5px',
              },
            },
            body1: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '6px',
              },
            },
            body2: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '5px',
              },
            },
            body3: {
              left: {
                marginRight: '1px',
              },
              right: {
                marginLeft: '4px',
              },
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(2px)',
            },
            h2: {
              transform: 'translateY(2px)',
            },
            h3: {
              transform: 'translateY(2px)',
            },
            h4: {
              transform: 'translateY(1px)',
            },
            body1: {
              transform: 'translateY(1px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(1px)',
            },
          },
        },
        medium: {
          iconSizeMapping: {
            h1: {
              width: '18px',
              height: '18px',
            },
            h2: {
              width: '16px',
              height: '16px',
            },
            h3: {
              width: '13px',
              height: '13px',
            },
            h4: {
              width: '10px',
              height: '10px',
            },
            body1: {
              width: '13px',
              height: '13px',
            },
            body2: {
              width: '12px',
              height: '12px',
            },
            body3: {
              width: '10px',
              height: '10px',
            },
          },
          directionMapping: {
            h1: {
              left: {
                marginRight: '3px',
              },
              right: {
                marginLeft: '8px',
              },
            },
            h2: {
              left: {
                marginRight: '3px',
              },
              right: {
                marginLeft: '7px',
              },
            },
            h3: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '6px',
              },
            },
            h4: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '5px',
              },
            },
            body1: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '6px',
              },
            },
            body2: {
              left: {
                marginRight: '2px',
              },
              right: {
                marginLeft: '5px',
              },
            },
            body3: {
              left: {
                marginRight: '1px',
              },
              right: {
                marginLeft: '4px',
              },
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(2px)',
            },
            h2: {
              transform: 'translateY(2px)',
            },
            h3: {
              transform: 'translateY(1px)',
            },
            h4: {
              transform: 'translateY(1px)',
            },
            body1: {
              transform: 'translateY(1px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(1px)',
            },
          },
        },
      },
    },
    backLink: {
      icon: '#333333',
    },
    expandLink: {
      icon: {
        variantMapping: {
          light: {
            color: '#333333',
            fill: '#333333',
          },
          dark: {
            color: '#FFFFFF',
            fill: '#FFFFFF',
          },
        },
      },
      compact: {
        directionMapping: {
          h1: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h2: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h3: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
          },
          h4: {
            left: {
              marginRight: '6px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body1Title: {
            left: {
              marginRight: '6px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body1: {
            left: {
              marginRight: '6px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body2Title: {
            left: {
              marginRight: '6px',
            },
            right: {
              marginLeft: '6px',
            },
          },
          body2: {
            left: {
              marginRight: '6px',
            },
            right: {
              marginLeft: '6px',
            },
          },
        },
        iconSizeMapping: {
          h1: {
            width: '22px',
            height: '22px',
          },
          h2: {
            width: '17px',
            height: '17px',
          },
          h3: {
            width: '14px',
            height: '14px',
          },
          h4: {
            width: '14px',
            height: '14px',
          },
          body1: {
            width: '12px',
            height: '12px',
          },
          body1Title: {
            width: '12px',
            height: '12px',
          },
          body2: {
            width: '9px',
            height: '9px',
          },
          body2Title: {
            width: '9px',
            height: '9px',
          },
        },
        transformMapping: {
          h1: {
            transform: 'translateY(13px)',
          },
          h2: {
            transform: 'translateY(10px)',
          },
          h3: {
            transform: 'translateY(9px)',
          },
          h4: {
            transform: 'translateY(8px)',
          },
          body1: {
            transform: 'translateY(6px)',
          },
          body1Title: {
            transform: 'translateY(6px)',
          },
          body2: {
            transform: 'translateY(6px)',
          },
          body2Title: {
            transform: 'translateY(6px)',
          },
        },
      },
      hBreakpoints: {
        directionMapping: {
          left: {
            marginRight: '8px',
          },
          right: {
            marginLeft: '8px',
          },
        },
        minExtraLarge: {
          iconSizeMapping: {
            h1: {
              width: '41px',
              height: '41px',
            },
            h2: {
              width: '30px',
              height: '30px',
            },
            h3: {
              width: '23px',
              height: '23px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(26px)',
            },
            h2: {
              transform: 'translateY(22px)',
            },
            h3: {
              transform: 'translateY(17px)',
            },
            h4: {
              transform: 'translateY(12px)',
            },
            body1: {
              transform: 'translateY(7px)',
            },
            body2: {
              transform: 'translateY(4px)',
            },
            body3: {
              transform: 'translateY(2px)',
            },
          },
        },
        extraLarge: {
          iconSizeMapping: {
            h1: {
              width: '32px',
              height: '32px',
            },
            h2: {
              width: '25px',
              height: '25px',
            },
            h3: {
              width: '20px',
              height: '20px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(20px)',
            },
            h2: {
              transform: 'translateY(17px)',
            },
            h3: {
              transform: 'translateY(15px)',
            },
            h4: {
              transform: 'translateY(11px)',
            },
            body1: {
              transform: 'translateY(7px)',
            },
            body2: {
              transform: 'translateY(4px)',
            },
            body3: {
              transform: 'translateY(2px)',
            },
          },
        },
        medium: {
          iconSizeMapping: {
            h1: {
              width: '24px',
              height: '24px',
            },
            h2: {
              width: '20px',
              height: '20px',
            },
            h3: {
              width: '18px',
              height: '18px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(16px)',
            },
            h2: {
              transform: 'translateY(15px)',
            },
            h3: {
              transform: 'translateY(11px)',
            },
            h4: {
              transform: 'translateY(8px)',
            },
            body1: {
              transform: 'translateY(7px)',
            },
            body2: {
              transform: 'translateY(4px)',
            },
            body3: {
              transform: 'translateY(2px)',
            },
          },
        },
      },
    },
    iconLink: {
      icon: {
        direction: {
          left: {
            marginRight: '8px',
          },
          right: {
            marginLeft: '8px',
          },
        },
        modeMapping: {
          light: {
            color: '#333333',
            fill: '#333333',
          },
          dark: {
            color: '#FFFFFF',
            fill: '#FFFFFF',
          },
        },
      },
      compact: {
        variantMapping: {
          h1: {
            width: '24px',
            height: '24px',
          },
          h2: {
            width: '24px',
            height: '24px',
          },
          h3: {
            width: '24px',
            height: '24px',
          },
          h4: {
            width: '21px',
            height: '21px',
          },
          body1: {
            width: '18px',
            height: '18px',
          },
          body1Title: {
            width: '18px',
            height: '18px',
          },
          body2: {
            width: '18px',
            height: '18px',
          },
          body2Title: {
            width: '18px',
            height: '18px',
          },
        },
      },
      hBreakpoints: {
        minExtraLarge: {
          variantMapping: {
            h1: {
              width: '41px',
              height: '41px',
            },
            h2: {
              width: '30px',
              height: '30px',
            },
            h3: {
              width: '23px',
              height: '23px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(12px)',
            },
            h2: {
              transform: 'translateY(11px)',
            },
            h3: {
              transform: 'translateY(10px)',
            },
            h4: {
              transform: 'translateY(7px)',
            },
            body1: {
              transform: 'translateY(3px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(0px)',
            },
          },
        },
        extraLarge: {
          variantMapping: {
            h1: {
              width: '32px',
              height: '32px',
            },
            h2: {
              width: '25px',
              height: '25px',
            },
            h3: {
              width: '20px',
              height: '20px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(9px)',
            },
            h2: {
              transform: 'translateY(9px)',
            },
            h3: {
              transform: 'translateY(8px)',
            },
            h4: {
              transform: 'translateY(6px)',
            },
            body1: {
              transform: 'translateY(3px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(0px)',
            },
          },
        },
        medium: {
          variantMapping: {
            h1: {
              width: '24px',
              height: '24px',
            },
            h2: {
              width: '20px',
              height: '20px',
            },
            h3: {
              width: '18px',
              height: '18px',
            },
            h4: {
              width: '18px',
              height: '18px',
            },
            body1: {
              width: '18px',
              height: '18px',
            },
            body2: {
              width: '18px',
              height: '18px',
            },
            body3: {
              width: '18px',
              height: '18px',
            },
          },
          transformMapping: {
            h1: {
              transform: 'translateY(8px)',
            },
            h2: {
              transform: 'translateY(8px)',
            },
            h3: {
              transform: 'translateY(6px)',
            },
            h4: {
              transform: 'translateY(4px)',
            },
            body1: {
              transform: 'translateY(3px)',
            },
            body2: {
              transform: 'translateY(1px)',
            },
            body3: {
              transform: 'translateY(0px)',
            },
          },
        },
      },
    },
  },
  countdownIndicator: {
    base: {
      color: {
        light: {
          foreColor: '#4D6474',
          backColor: 'rgba(77, 100, 116, 0.1)',
          fontColor: '#333333',
        },
        dark: {
          foreColor: '#FFFFFF',
          backColor: 'rgba(255, 255, 255, 0.2)',
          fontColor: '#FFFFFF',
        },
      },
    },
    compact: {
      label: {
        variantMapping: {
          timeLabel: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
          descriptionLabel: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
        },
        positionMap: {
          large: {
            right: {
              marginRight: '10px',
            },
            bottom: {
              marginBottom: '6px',
            },
          },
          medium: {
            right: {
              marginRight: '10px',
            },
            bottom: {
              marginBottom: '6px',
            },
          },
          small: {
            right: {
              marginRight: '10px',
            },
            bottom: {
              marginBottom: '6px',
            },
          },
        },
      },
      variantMapping: {
        size: {
          small: {
            width: '30px',
            height: '30px',
          },
          medium: {
            width: '45px',
            height: '45px',
          },
          large: {
            width: '60px',
            height: '60px',
          },
        },
      },
    },
    hBreakpoints: {
      label: {
        variantMapping: {
          timeLabel: {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
          descriptionLabel: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
        },
        positionMap: {
          large: {
            right: {
              marginRight: '12px',
            },
            bottom: {
              marginBottom: '4px',
            },
          },
          medium: {
            right: {
              marginRight: '8px',
            },
            bottom: {
              marginBottom: '0',
            },
          },
          small: {
            right: {
              marginRight: '8px',
            },
            bottom: {
              marginBottom: '0',
            },
          },
        },
      },
      variantMapping: {
        size: {
          small: {
            width: '32px',
            height: '32px',
          },
          medium: {
            width: '44px',
            height: '44px',
          },
          large: {
            width: '56px',
            height: '56px',
          },
        },
      },
    },
  },
  datepicker: {
    base: {
      inputBox: {
        backgroundColor: '#FFFFFF',
        width: '100%',
        border: '1px solid #333333',
        cursor: 'text',
        color: '#333333',
        paddingLeft: '10px',
        paddingRight: '40px',
        overflow: 'hidden',
        invalid: {
          borderColor: '#A8000B',
          backgroundColor: '#F9F2F3',
        },
        sizeMapping: {
          large: {
            inputIconButton: {
              height: '30px',
            },
            inputBox: {
              height: '40px',
            },
          },
          small: {
            inputIconButton: {
              height: '20px',
            },
            inputBox: {
              height: '30px',
            },
          },
        },
      },
    },
    compact: {
      monthTitle: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      dayTitle: {
        display: 'inline-block',
        color: '#000000',
        fontSize: '12px',
        fontWeight: 400,
        width: '40px',
        textAlign: 'center',
        letterSpacing: 'normal',
      },
      day: {
        large: {
          display: 'inline-block',
          color: '#333333',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '40px',
          width: '40px',
          textAlign: 'center',
          letterSpacing: 'normal',
        },
        small: {
          display: 'inline-block',
          color: '#333333',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '30px',
          width: '40px',
          textAlign: 'center',
          letterSpacing: 'normal',
        },
      },
      subTitle: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
      presetButton: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: 'normal',
      },
    },
    hBreakpoints: {
      extraLarge: {
        day: {
          fontSize: '16px',
          fontWeight: 300,
        },
        dayTitle: {
          fontSize: '12px',
          fontWeight: 300,
        },
        monthTitle: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        subTitle: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        presetButton: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
        inputBox: {
          height: '44px',
        },
        inputIconButton: {
          height: '34px',
        },
      },
    },
  },
  dnd: {
    droppable: {
      base: {
        position: 'relative',
        background: '#FFFFFF',
        '.bottomLine': {
          margin: 0,
          border: 'none',
          borderBottom: '1px solid #D7D8D6',
        },
      },
    },
    draggable: {
      base: {
        userSelect: 'none',
        background: '#FFFFFF',
        padding: '11px 10px',
        border: '1px solid transparent',
        borderTop: '1px solid #D7D8D6',
        borderBottom: 'none',
        '&:hover': {
          border: '1px solid #3E505D',
          borderBottom: 'none',
          "& + [data-testid='Draggable']": {
            borderTop: '1px solid #3E505D',
          },
          '& + .bottomLine': {
            borderBottom: '1px solid #3E505D',
          },
        },
        '&:active': {
          cursor: 'grabbing',
        },
        '&.isDragging': {
          border: '1px solid #3E505D',
          'box-shadow': '0 2px 6px 2px rgba(0, 0, 0, 0.2)',
        },
      },
    },
  },
  forms: {
    base: {},
  },
  image: {
    base: {
      textDecoration: 'none',
    },
    compact: {
      padding: '16px 20px 8px',
    },
    hBreakpoints: {
      extraLarge: {
        base: {
          padding: '16px 20px 8px',
        },
      },
      medium: {
        base: {
          padding: '12px 16px 6px',
        },
      },
    },
  },
  list: {
    base: {
      listStyleType: 'none',
    },
    compact: {
      transformMapping: {
        h1: {
          transform: 'translateY(6px)',
        },
        h2: {
          transform: 'translateY(3px)',
        },
        h3: {
          transform: 'translateY(2px)',
        },
        h4: {
          transform: 'translateY(1px)',
        },
        body1: {
          transform: 'translateY(0px)',
        },
        body1Title: {
          transform: 'translateY(0px)',
        },
        body2: {
          transform: 'translateY(-1px)',
        },
        body2Title: {
          transform: 'translateY(-1px)',
        },
      },
    },
    hBreakpoints: {
      minExtraLarge: {
        transformMapping: {
          h1: {
            transform: 'translateY(20px)',
          },
          h2: {
            transform: 'translateY(14px)',
          },
          h3: {
            transform: 'translateY(10px)',
          },
          h4: {
            transform: 'translateY(5px)',
          },
          body1: {
            transform: 'translateY(3px)',
          },
          body2: {
            transform: 'translateY(0px)',
          },
          body3: {
            transform: 'translateY(-2px)',
          },
        },
      },
      extraLarge: {
        transformMapping: {
          h1: {
            transform: 'translateY(14px)',
          },
          h2: {
            transform: 'translateY(12px)',
          },
          h3: {
            transform: 'translateY(6px)',
          },
          h4: {
            transform: 'translateY(5px)',
          },
          body1: {
            transform: 'translateY(3px)',
          },
          body2: {
            transform: 'translateY(0px)',
          },
          body3: {
            transform: 'translateY(-2px)',
          },
        },
      },
      medium: {
        transformMapping: {
          h1: {
            transform: 'translateY(8px)',
          },
          h2: {
            transform: 'translateY(8px)',
          },
          h3: {
            transform: 'translateY(4px)',
          },
          h4: {
            transform: 'translateY(4px)',
          },
          body1: {
            transform: 'translateY(2px)',
          },
          body2: {
            transform: 'translateY(0px)',
          },
          body3: {
            transform: 'translateY(-1px)',
          },
        },
      },
    },
  },
  modal: {
    sizeMapping: {
      small: {
        padding: '30px',
        '.closeIcon': {
          top: '10px',
          right: '10px',
        },
        footer: {
          marginBottom: '-15px',
        },
      },
    },
    disableSidesPadding: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
    },
    hBreakpoints: {
      large: {
        base: {
          padding: '44px 20px 24px',
          margin: '44px 20px',
          border: 'none',
        },
      },
      medium: {
        base: {
          padding: '44px 16px 20px',
          margin: '44px 16px',
          border: 'none',
        },
      },
      extraSmall: {
        base: {
          padding: '44px 16px 20px',
          margin: '44px 8px',
          border: 'none',
        },
      },
    },
  },
  nativeDropdown: {
    variants: {
      primary: {
        bg: '#fff',
        border: '#2278ce',
        color: '#333',
      },
      secondary: {
        bg: '#f9f2f3',
        border: '#a8000b',
        color: '#333',
      },
    },
    select: {
      paddingLeft: '10px',
      paddingRight: '50px',
      border: 'solid 1px #333',
      color: '#333',
      backgroundColor: '#fff',
      fontSize: '14px',
      height: '40px',
      small: {
        height: '30px',
        fontSize: '12px',
      },
      '&.small': {
        height: '30px',
        fontSize: '12px',
      },
      '&.extraLarge': {
        height: '44px',
      },
      '&.selectTitle': {
        fontSize: '12px',
        height: '54px',
        paddingTop: '28px',
        paddingBottom: '10px',
      },
      '&.dark': {
        border: 'solid 1px #fff',
        color: '#fff',
        backgroundColor: 'transparent',
      },
    },
    option: {
      backgroundColor: '#fff',
      color: '#333',
    },
    iconWrapper: {
      width: '36px',
      height: '22px',
      top: '50%',
      transform: 'translateY(-50%)',
      marginRight: '1px',
      borderLeft: 'solid 1px #767676',
      '&.dark': {
        borderLeft: 'solid 1px #fff',
      },
      small: {
        height: '16px',
      },
      '&.small': {
        height: '16px',
      },
      '&.selectTitle': {
        height: '32px',
      },
    },
    selectTitle: {
      color: '#5c5c5c',
      fontSize: '12px',
      top: '8px',
      left: '11px',
      '&.dark': {
        color: '#fff',
      },
    },
    hBreakpoints: {
      extraLarge: {
        select: {
          height: '44px',
          fontSize: '14px',
          '&.small': {
            height: '44px',
            fontSize: '14px',
          },
        },
        iconWrapper: {
          height: '22px',
          '&.small': {
            height: '22px',
          },
        },
      },
    },
  },
  notifications: {
    base: {
      variantMapping: {
        compact: {
          paddingLeft: '20px',
          paddingRight: '8px',
          paddingY: '15px',
          borderWidth: '1px',
        },
        hBreakpoints: {
          extraLarge: {
            paddingLeft: '20px',
            paddingRight: '18px',
            paddingY: '13px',
            borderWidth: '1px',
          },
          medium: {
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingY: '9px',
            borderWidth: '1px',
          },
        },
      },
    },
    icon: {
      variantMap: {
        system: {
          error: {
            name: 'StatusErrorDark',
          },
          warning: {
            name: 'StatusWarningAmber',
          },
          success: {
            name: 'StatusConfirmationDark',
          },
          info: {
            name: 'StatusInformationDark',
          },
        },
        contextual: {
          error: {
            name: 'StatusErrorLight',
          },
          warning: {
            name: 'StatusWarningLight',
          },
          success: {
            name: 'StatusConfirmationLight',
          },
          info: {
            name: 'StatusInformationLight',
          },
        },
        inline: {
          error: {
            name: 'StatusErrorLight',
          },
          warning: {
            name: 'StatusWarningLight',
          },
          success: {
            name: 'StatusConfirmationLight',
          },
          info: {
            name: 'StatusInformationLight',
          },
        },
        inlineDark: {
          error: {
            name: 'StatusErrorDark',
          },
          warning: {
            name: 'StatusWarningAmber',
          },
          success: {
            name: 'StatusConfirmationDark',
          },
          info: {
            name: 'StatusInformationDark',
          },
        },
      },
    },
    contentWrapper: {
      compact: {
        horizontalSpacing: {
          marginLeft: '8px',
        },
        verticalSpacing: {
          '.Notification-title': {
            marginBottom: '10px',
          },
          '.Notification-title ~ :not(:last-child)': {
            marginBottom: '7px',
          },
        },
      },
      hBreakpoints: {
        extraLarge: {
          horizontalSpacing: {
            marginLeft: '12px',
          },
          verticalSpacing: {
            '.Notification-title': {
              marginBottom: '15px',
            },
            '.Notification-title ~ :not(:last-child)': {
              marginBottom: '11px',
            },
          },
        },
        medium: {
          horizontalSpacing: {
            marginLeft: '8px',
          },
          verticalSpacing: {
            '.Notification-title': {
              marginBottom: '11px',
            },
            '.Notification-title ~ :not(:last-child)': {
              marginBottom: '11px',
            },
          },
        },
      },
    },
    closeButton: {
      variantMap: {
        system: {
          error: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
          warning: {
            name: 'StatusNo',
            color: '#333333',
          },
          success: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
          info: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
        },
        contextual: {
          error: {
            name: 'StatusNo',
            color: '#333333',
          },
          warning: {
            name: 'StatusNo',
            color: '#333333',
          },
          success: {
            name: 'StatusNo',
            color: '#333333',
          },
          info: {
            name: 'StatusNo',
            color: '#333333',
          },
        },
        inline: {
          error: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
          warning: {
            name: 'StatusNo',
            color: '#333333',
          },
          success: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
          info: {
            name: 'StatusNo',
            color: '#FFFFFF',
          },
        },
      },
    },
    variantMap: {
      system: {
        error: {
          borderStyle: 'solid',
          backgroundColor: '#A8000B',
          borderColor: '#A8000B',
          color: '#FFFFFF',
        },
        warning: {
          borderStyle: 'solid',
          backgroundColor: '#FFBB33',
          borderColor: '#FFBB33',
          color: '#333333',
        },
        success: {
          borderStyle: 'solid',
          backgroundColor: '#00847F',
          borderColor: '#00847F',
          color: '#FFFFFF',
        },
        info: {
          borderStyle: 'solid',
          backgroundColor: '#305A85',
          borderColor: '#305A85',
          color: '#FFFFFF',
        },
      },
      contextual: {
        error: {
          borderStyle: 'solid',
          backgroundColor: '#F9F2F3',
          borderColor: '#A8000B',
          color: '#333333',
        },
        warning: {
          borderStyle: 'solid',
          backgroundColor: '#FFF8EA',
          borderColor: '#FFBB33',
          color: '#333333',
        },
        success: {
          borderStyle: 'solid',
          backgroundColor: '#E5F2F2',
          borderColor: '#00847F',
          color: '#333333',
        },
        info: {
          borderStyle: 'solid',
          backgroundColor: '#EBEFF4',
          borderColor: '#305A85',
          color: '#333333',
        },
      },
      inline: {
        error: {
          color: '#333333',
        },
        warning: {
          color: '#333333',
        },
        success: {
          color: '#333333',
        },
        info: {
          color: '#333333',
        },
      },
    },
    sizeMapping: {
      small: {
        paddingY: '10px',
      },
      large: {
        paddingY: '15px',
      },
    },
  },
  pills: {
    base: {
      display: 'inline-flex',
      'align-items': 'center',
      cursor: 'pointer',
      borderWidth: '1px',
      borderStyle: 'solid',
      textAlign: 'left',
      textDecoration: 'none',
      'user-select': 'none',
    },
    variantMapping: {
      light: {
        unselected: {
          backgroundColor: 'transparent',
          borderColor: '#333333',
          color: '#333333',
          '&:hover': {
            backgroundColor: '#F1F3F4',
            borderColor: '#333333',
            color: '#333333',
          },
          '&:active': {
            backgroundColor: '#E4E8EA',
            borderColor: '#333333',
            color: '#333333',
          },
          '&.disabled': {
            border: '1px solid #333333',
            color: '#333333',
            opacity: 0.3,
            backgroundColor: 'transparent',
            cursor: 'not-allowed',
          },
        },
        selected: {
          backgroundColor: '#4D6474',
          borderColor: '#4D6474',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D',
            color: '#FFFFFF',
          },
          '&:active': {
            backgroundColor: '#1D262C',
            borderColor: '#1D262C',
            color: '#FFFFFF',
          },
          '&.disabled': {
            border: '1px solid #4D6474',
            color: '#FFFFFF',
            opacity: 0.2,
            backgroundColor: '#4D6474',
            cursor: 'not-allowed',
          },
        },
      },
      dark: {
        unselected: {
          backgroundColor: 'transparent',
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#4D6474',
            borderColor: '#4D6474 ',
            color: '#FFFFFF',
          },
          '&:active': {
            backgroundColor: '#3E505D',
            borderColor: '#3E505D ',
            color: '#FFFFFF',
          },
          '&.disabled': {
            border: '1px solid #FFFFFF',
            color: '#FFFFFF',
            opacity: 0.35,
            backgroundColor: 'transparent',
            cursor: 'not-allowed',
          },
        },
        selected: {
          backgroundColor: '#FFFFFF',
          borderColor: '#FFFFFF',
          color: '#333333',
          '&:hover': {
            backgroundColor: '#F1F3F4',
            borderColor: '#F1F3F4 ',
            color: '#333333',
          },
          '&:active': {
            backgroundColor: '#E4E8EA',
            borderColor: '#E4E8EA ',
            color: '#333333',
          },
          '&.disabled': {
            border: '1px solid #FFFFFF',
            color: '#333333',
            opacity: 0.25,
            backgroundColor: '#FFFFFF',
            cursor: 'not-allowed',
          },
        },
      },
    },
    compact: {
      sizeMapping: {
        large: {
          padding: '0px 10px',
          borderRadius: '16px',
          minHeight: '32px',
          height: 'fit-content',
        },
        small: {
          padding: '0px 8px',
          borderRadius: '11px',
          minHeight: '22px',
          height: 'fit-content',
        },
      },
      fontSizeMapping: {
        large: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        small: {
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
      },
    },
    hBreakpoints: {
      extraLarge: {
        base: {
          padding: '8px 12px',
          borderRadius: '18px',
          minHeight: '36px',
          fontWeight: 500,
          lineHeight: '14px',
        },
        fontSize: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
      },
      medium: {
        base: {
          padding: '8px 12px',
          borderRadius: '18px',
          minHeight: '36px',
          fontWeight: 500,
          lineHeight: '14px',
        },
        fontSize: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
      },
    },
  },
  progressTracker: {
    base: {
      backgroundColor: 'green',
      paddingX: '10px',
      paddingY: '10px',
      marginRight: '3px',
    },
    triangle: {
      variantMapping: {
        past: {
          '&:after': {
            borderLeftColor: '#005E59',
          },
          '&:before': {
            borderLeftColor: 'white',
          },
        },
        present: {
          '&:after': {
            borderLeftColor: '#00847F',
          },
          '&:before': {
            borderLeftColor: 'white',
          },
        },
        future: {
          '&:after': {
            borderLeftColor: '#D9EDEC',
          },
          '&:before': {
            borderLeftColor: 'white',
          },
        },
      },
    },
    variantMapping: {
      past: {
        color: '#FFFFFF',
        backgroundColor: '#005E59',
        '&:after': {
          borderLeftColor: '#005E59',
        },
      },
      present: {
        color: '#FFFFFF',
        backgroundColor: '#00847F',
        '&:after': {
          borderLeftColor: '#00847F',
        },
      },
      future: {
        color: '#333333',
        backgroundColor: '#D9EDEC',
        '&:after': {
          borderLeftColor: '#D9EDEC',
        },
      },
    },
    sizeMapping: {
      segmentHeight: {
        small: {
          height: '30px',
        },
        large: {
          height: '36px',
        },
        multiline: {
          height: '52px',
        },
      },
      triangle: {
        small: {
          after: {
            borderTop: '15px solid transparent',
            borderBottom: '15px solid transparent',
            borderLeftWidth: '15px',
            left: '100%',
          },
          before: {
            borderTop: '15px solid transparent',
            borderBottom: '15px solid transparent',
            borderLeftWidth: '15px',
          },
        },
        large: {
          after: {
            borderTop: '18px solid transparent',
            borderBottom: '18px solid transparent',
            borderLeftWidth: '18px',
            left: '100%',
          },
          before: {
            borderTop: '18px solid transparent',
            borderBottom: '18px solid transparent',
            borderLeftWidth: '18px',
          },
        },
        multiline: {
          after: {
            borderTop: '26px solid transparent',
            borderBottom: '26px solid transparent',
            borderLeftWidth: '26px',
            left: '100%',
          },
          before: {
            borderTop: '26px solid transparent',
            borderBottom: '26px solid transparent',
            borderLeftWidth: '26px',
          },
        },
      },
    },
  },
  radio: {
    icon: {
      light: {
        fill: '#00847F',
      },
      dark: {
        fill: '#00847F',
      },
    },
    stateMapping: {
      invalid: {
        borderColor: '#A8000B',
        backgroundColor: '#F9F2F3',
      },
    },
    compact: {
      sizeMapping: {
        small: {
          width: '20px',
          height: '20px',
        },
        large: {
          width: '30px',
          height: '30px',
        },
      },
      variantMapping: {
        light: {
          borderColor: '#767676',
          '&:hover': {
            borderColor: '#2278CE',
          },
        },
        dark: {
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          '&:hover': {
            borderColor: '#2278CE',
          },
        },
      },
      label: {
        base: {
          paddingLeft: '9px',
          color: '#333333',
          cursor: 'pointer',
          marginRight: '10px!important',
        },
        large: {
          transform: 'translateY(-2px)',
        },
        small: {},
      },
      paddingVertical: '5',
    },
    hBreakpoints: {
      size: {
        base: {
          width: '32px',
          height: '32px',
        },
      },
      variantMapping: {
        light: {
          borderColor: '#767676',
          '&:hover': {
            borderColor: '#2278CE',
          },
        },
        dark: {
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          '&:hover': {
            borderColor: '#2278CE',
          },
        },
      },
      label: {
        base: {
          paddingLeft: '12px',
          color: '#333333',
          cursor: 'pointer',
          marginRight: '10px!important',
          transform: 'translateY(-2px)',
        },
      },
      paddingVertical: '6',
    },
  },
  responsiveProgressTracker: {
    progressBar: {
      backgroundColor: '#E4E8EA',
      height: '4px',
      marginTop: '6px',
    },
    progressFill: {
      backgroundColor: '#DB0011',
    },
    compact: {
      progressText: {
        progressTitle: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        stepNumber: {
          fontSize: '16px',
          fontWeight: 300,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        bottomTitle: {
          fontSize: '35px',
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: 'normal',
        },
      },
    },
    bottomSpacing: {
      marginTop: '24px',
    },
    hBreakpoints: {
      extraLarge: {
        progressText: {
          progressTitle: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
          stepNumber: {
            fontSize: '16px',
            fontWeight: 300,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
          bottomTitle: {
            fontSize: '35px',
            fontWeight: 300,
            lineHeight: 1.2,
            letterSpacing: 'normal',
          },
        },
      },
      medium: {
        progressText: {
          progressTitle: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
          stepNumber: {
            fontSize: '16px',
            fontWeight: 300,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
          bottomTitle: {
            fontSize: '28px',
            fontWeight: 300,
            lineHeight: 1.3,
            letterSpacing: 'normal',
          },
        },
      },
    },
  },
  scrollbar: {
    base: {
      '&::-webkit-scrollbar': {
        width: '10px',
        height: '10px',
        backgroundColor: '#E4E8EA',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#3E505D',
        '&:hover': {
          backgroundColor: '#4D6474',
        },
        '&:active': {
          backgroundColor: '#1D262C',
        },
      },
    },
  },
  sectionTitle: {
    brandBar: {
      base: {
        backgroundColor: '#DB0011',
        width: '3px',
      },
      compact: {
        sizeMapping: {
          h1: {
            height: '34px',
          },
          h2: {
            height: '27px',
          },
          h3: {
            height: '23px',
          },
          h4: {
            height: '21px',
          },
        },
      },
      hBreakpoints: {
        minExtraLarge: {
          sizeMapping: {
            h1: {
              height: '62px',
            },
            h2: {
              height: '46px',
            },
            h3: {
              height: '34px',
            },
            h4: {
              height: '26px',
            },
          },
        },
        extraLarge: {
          sizeMapping: {
            h1: {
              height: '48px',
            },
            h2: {
              height: '39px',
            },
            h3: {
              height: '30px',
            },
            h4: {
              height: '24px',
            },
          },
        },
        medium: {
          sizeMapping: {
            h1: {
              height: '36px',
            },
            h2: {
              height: '30px',
            },
            h3: {
              height: '26px',
            },
            h4: {
              height: '21px',
            },
          },
        },
      },
    },
    variantMapping: {
      light: {
        color: '#333333',
      },
      dark: {
        color: '#FFFFFF',
      },
    },
    compact: {
      title: {
        paddingLeft: '13px',
      },
      sizeMapping: {
        h1: {
          minHeight: '34px',
          height: 'fit-content',
          lineHeight: '1.3',
        },
        h2: {
          minHeight: '27px',
          height: 'fit-content',
          lineHeight: '1.3',
        },
        h3: {
          minHeight: '23px',
          height: 'fit-content',
          lineHeight: '1.27',
        },
        h4: {
          minHeight: '21px',
          height: 'fit-content',
          lineHeight: '1.31',
        },
      },
    },
    hBreakpoints: {
      minExtraLarge: {
        title: {
          paddingLeft: '24px',
        },
        sizeMapping: {
          h1: {
            minHeight: '62px',
            lineHeight: '1.08',
            height: 'fit-content',
          },
          h2: {
            minHeight: '46px',
            lineHeight: '1.07',
            height: 'fit-content',
          },
          h3: {
            minHeight: '34px',
            lineHeight: '1.06',
            height: 'fit-content',
          },
          h4: {
            minHeight: '26px',
            lineHeight: '1.08',
            height: 'fit-content',
          },
        },
      },
      extraLarge: {
        title: {
          paddingLeft: '20px',
        },
        sizeMapping: {
          h1: {
            minHeight: '48px',
            lineHeight: '1.09',
            height: 'fit-content',
          },
          h2: {
            minHeight: '39px',
            lineHeight: '1.07',
            height: 'fit-content',
          },
          h3: {
            minHeight: '30px',
            lineHeight: '1.07',
            height: 'fit-content',
          },
          h4: {
            minHeight: '24px',
            lineHeight: '1.09',
            height: 'fit-content',
          },
        },
      },
      medium: {
        title: {
          paddingLeft: '16px',
        },
        sizeMapping: {
          h1: {
            minHeight: '36px',
            lineHeight: '1.09',
            height: 'fit-content',
          },
          h2: {
            minHeight: '30px',
            lineHeight: '1.07',
            height: 'fit-content',
          },
          h3: {
            minHeight: '26px',
            lineHeight: '1.1',
            height: 'fit-content',
          },
          h4: {
            minHeight: '21px',
            lineHeight: '1.1',
            height: 'fit-content',
          },
        },
      },
    },
  },
  selectionTile: {
    base: {
      display: 'inline-block',
      'background-color': '#FFFFFF',
    },
    content: {
      base: {
        'border-color': '#D7D8D6',
        'border-style': 'solid',
        'border-width': '1px',
        cursor: 'pointer',
      },
      selected: {
        'border-color': '#00847F',
        'box-shadow': '0px 0px 0px 1px #00847F',
      },
      invalid: {
        'border-color': '#A8000B',
      },
      invalidIcon: {
        'border-color': '#A8000B',
        'background-color': '#F9F2F3',
      },
    },
    compact: {
      icon: {
        'margin-right': '10px',
      },
      selectionIcon: {
        'margin-left': '10px',
      },
      sizeMapping: {
        tile: {
          small: {
            'padding-top': '10px',
            'padding-bottom': '10px',
            'padding-left': ' 16px',
            'padding-right': ' 16px',
          },
          large: {
            'padding-top': '14px',
            'padding-bottom': '14px',
            'padding-left': '16px',
            'padding-right': '16px',
          },
        },
        separator: {
          small: {
            'margin-bottom': '10px',
          },
          large: {
            'margin-bottom': '14px',
          },
        },
        description: {
          'padding-top': '0',
          'padding-bottom': '16px',
          'padding-left': '20px',
          'padding-right': '20px',
        },
      },
    },
    hBreakpoints: {
      icon: {
        'margin-right': '12px',
      },
      selectionIcon: {
        'margin-left': '12px',
      },
      sizeMapping: {
        tile: {
          small: {
            padding: '16px',
          },
          large: {
            'padding-top': '16px',
            'padding-bottom': '16px',
            'padding-left': '20px',
            'padding-right': '20px',
          },
        },
        separator: {
          small: {
            'margin-bottom': '12px',
          },
          large: {
            'margin-bottom': '16px',
          },
        },
        description: {
          small: {
            'padding-top': '0',
            'padding-bottom': '16px',
            'padding-left': '16px',
            'padding-right': '16px',
          },
          large: {
            'padding-top': '0',
            'padding-bottom': '20px',
            'padding-left': '20px',
            'padding-right': '20px',
          },
        },
      },
    },
  },
  slider: {
    trackStyle: {
      height: '8px',
      borderRadius: 0,
      backgroundColor: '#00847F',
    },
    railStyle: {
      height: '8px',
      borderRadius: 0,
      backgroundColor: '#C9D0D5',
    },
    draggingStyle: {
      borderColor: '#2278CE',
      backgroundColor: '#C9D0D5',
      boxShadow: 'none',
    },
    handle: {
      base: {
        position: 'absolute',
        cursor: 'grab',
        touchAction: 'pan-x',
        borderRadius: '50%',
        border: '1px solid #767676',
        backgroundColor: '#FFFFFF',
        transform: 'none',
        opacity: '1',
        '&:active': {
          cursor: 'grabbing',
        },
        '&:hover': {
          borderColor: '#2278CE',
        },
      },
    },
    compact: {
      sliderStyle: {
        small: {
          padding: '8px 0',
          marginTop: '10px',
        },
        large: {
          padding: '13px 0',
          marginTop: '10px',
        },
      },
      handle: {
        small: {
          height: '24px',
          width: '24px',
          marginLeft: '-12px',
          marginTop: '-8px',
        },
        large: {
          height: '30px',
          width: '30px',
          marginLeft: '-15px',
          marginTop: '-11px',
        },
      },
      markerStyle: {
        small: {
          width: '1px',
          height: '10px',
          backgroundColor: '#767676',
          border: 'none',
          bottom: '3px',
        },
        large: {
          width: '1px',
          height: '12px',
          backgroundColor: '#767676',
          border: 'none',
          bottom: '3px',
        },
      },
      typograph: {
        large: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        small: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
      },
    },
    hBreakpoints: {
      sliderStyle: {
        base: {
          padding: '15px 0',
          marginTop: '12px',
        },
      },
      handle: {
        base: {
          height: '32px',
          width: '32px',
          marginLeft: '-16px',
          marginTop: '-12px',
        },
      },
      markerStyle: {
        base: {
          width: '1px',
          height: '16px',
          backgroundColor: '#767676',
          border: 'none',
          bottom: '3px',
        },
      },
      typograph: {
        base: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
      },
    },
  },
  sorts: {
    compact: {
      base: {
        borderRight: '1px solid #333333',
        backgroundColor: '#FFFFFF',
        '&:hover, &:focus': {
          backgroundColor: '#F1F3F4',
        },
        '&:active': {
          backgroundColor: '#E4E8EA',
        },
      },
      selected: {
        color: '#FFFFFF',
        backgroundColor: '#3E505D',
        '&:hover, &:focus': {
          backgroundColor: '#3E505D',
        },
        '&:active': {
          backgroundColor: '#3E505D',
        },
      },
      sizeMapping: {
        large: {
          base: {
            minHeight: '40px',
          },
          label: {
            paddingLeft: '19px',
            paddingRight: '19px',
          },
          icon: {
            paddingLeft: '10px',
            paddingRight: '10px',
          },
        },
        small: {
          base: {
            minHeight: '30px',
          },
          label: {
            paddingLeft: '19px',
            paddingRight: '19px',
          },
          icon: {
            paddingLeft: '6px',
            paddingRight: '6px',
          },
        },
      },
      typographMapping: {
        large: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        small: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
      },
      pointer: {
        borderColor: 'transparent',
        borderBottomColor: '#FFFFFF',
        borderWidth: '6px',
      },
      list: {
        border: '1px solid #333333',
        boxShadow: 'inset 0px 0px 0px 0.5px #3E505D',
      },
    },
    hBreakpoints: {
      base: {
        borderRight: '1px solid #333333',
        backgroundColor: '#FFFFFF',
        '&:hover, &:focus': {
          backgroundColor: '#F1F3F4',
        },
        '&:active': {
          backgroundColor: '#E4E8EA',
        },
      },
      selected: {
        backgroundColor: '#E4E8EA',
        '&:hover, &:focus': {
          backgroundColor: '#E4E8EA',
        },
        '&:active': {
          backgroundColor: '#E4E8EA',
        },
      },
      size: {
        base: {
          minHeight: '44px',
        },
        label: {
          paddingLeft: '19px',
          paddingRight: '19px',
        },
        icon: {
          paddingLeft: '12px',
          paddingRight: '12px',
        },
      },
      typographMapping: {
        large: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        small: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 1.4,
          letterSpacing: 'normal',
        },
      },
      pointer: {
        borderColor: 'transparent',
        borderBottomColor: '#333333',
        borderWidth: '6px',
      },
      list: {
        border: '1px solid #333333',
        boxShadow: 'inset 0px 0px 0px 0.5px #E4E8EA',
      },
    },
  },
  spinner: {
    base: {
      thickness: 2,
    },
    color: {
      light: '#333333',
      dark: '#FFFFFF',
    },
    compact: {
      label: {
        sizeMapping: {
          inline: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
          small: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
          medium: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: 'normal',
          },
          large: {
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: 1.31,
            letterSpacing: 'normal',
          },
        },
        positionMap: {
          inline: {
            left: {
              marginRight: '10px',
            },
            right: {
              marginLeft: '10px',
            },
            bottom: {
              marginTop: '5px',
            },
          },
          small: {
            left: {
              marginRight: '10px',
            },
            right: {
              marginLeft: '10px',
            },
            bottom: {
              marginTop: '5px',
            },
          },
          medium: {
            left: {
              marginRight: '10px',
            },
            right: {
              marginLeft: '10px',
            },
            bottom: {
              marginTop: '4px',
            },
          },
          large: {
            left: {
              marginRight: '10px',
            },
            right: {
              marginLeft: '10px',
            },
            bottom: {
              marginTop: '14px',
            },
          },
        },
      },
      variantMapping: {
        size: {
          buttonLoading: '20px',
          inline: '20px',
          small: '30px',
          medium: '45px',
          large: '60px',
        },
      },
    },
    hBreakpoints: {
      label: {
        sizeMapping: {
          inline: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.4,
            letterSpacing: 'normal',
          },
          small: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.4,
            letterSpacing: 'normal',
          },
          medium: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.4,
            letterSpacing: 'normal',
          },
          large: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: 'normal',
          },
        },
        positionMap: {
          inline: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
            bottom: {
              marginTop: '4px',
            },
          },
          small: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
            bottom: {
              marginTop: '4px',
            },
          },
          medium: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
            bottom: {
              marginTop: '4px',
            },
          },
          large: {
            left: {
              marginRight: '8px',
            },
            right: {
              marginLeft: '8px',
            },
            bottom: {
              marginTop: '8px',
            },
          },
        },
      },
      variantMapping: {
        size: {
          buttonLoading: '24px',
          inline: '24px',
          small: '32px',
          medium: '44px',
          large: '56px',
        },
      },
    },
  },
  table: {
    thead: {
      base: {},
      tSortLabel: {
        variantMapping: {
          small: {
            top: '12px',
            right: '10px',
          },
          large: {
            top: '17px',
            right: '10px',
          },
        },
      },
    },
    tableHeadRow: {
      base: {},
    },
    tableHeadCell: {
      base: {
        color: '#333333',
        backgroundColor: '#E4E8EA',
        borderLeft: 'solid 1px #FFFFFF',
        '&:first-child': {
          borderLeft: 'none',
        },
        '&.sortable__todo_remove': {
          paddingRight: '32px',
        },
        '&.sortActivied,&[aria-sort]:hover': {
          backgroundColor: '#3E505D',
          color: '#FFFFFF',
        },
        '&[aria-sort]:active': {
          backgroundColor: '#1D262C',
          color: '#FFFFFF',
        },
        '&:visited': {
          _todo: 'this bg color is missing in base...',
          backgroundColor: '#3E505D',
          color: '#FFFFFF',
        },
      },
      variantMapping: {
        small: {
          fontWeight: 500,
          padding: '10px',
          paddingTop: '5px',
          paddingBottom: '5px',
          height: '30px',
          lineHeight: '20px',
        },
        large: {
          fontWeight: 500,
          padding: '10px',
          height: '40px',
          lineHeight: '20px',
        },
      },
      fontSizeMapping: {
        small: {
          fontSize: '12px',
        },
        large: {
          fontSize: '14px',
        },
      },
      thSortLabel: {
        thSortIcon: {
          transform: 'translateY(10px) translateY(-50%)',
        },
      },
    },
    tableBodyRow: {
      base: {
        color: '#333333',
        borderTop: '1px solid #D7D8D6',
        borderLeft: '1px solid transparent',
        borderRight: '1px solid transparent',
        '&:first-child': {
          borderTopColor: 'transparent',
        },
        '&:last-child': {
          borderBottom: '1px solid #D7D8D6',
        },
      },
      variantMapping: {
        small: {
          height: '29px',
        },
        large: {
          height: '39px',
        },
      },
      selected: {
        backgroundColor: '#E5F2F2',
        borderTopColor: '#00847F',
        borderLeftColor: '#00847F',
        borderRightColor: '#00847F',
        '& + tr': {
          borderTopColor: '#00847F',
        },
        '&:first-child': {
          borderTopColor: '#00847F',
        },
        '&:last-child': {
          borderBottomColor: '#00847F',
        },
      },
      invalid: {
        backgroundColor: '#F9F2F3',
        borderTopColor: '#A8000B',
        borderLeftColor: '#A8000B',
        borderRightColor: '#A8000B',
        '& + tr': {
          borderTopColor: '#A8000B',
        },
        '&:first-child': {
          borderTopColor: '#A8000B',
        },
        '&:last-child': {
          borderBottomColor: '#A8000B',
        },
      },
      hovered: {
        '&.hovered:hover': {
          borderTopColor: '#3E505D',
          borderLeftColor: '#3E505D',
          borderRightColor: '#3E505D',
          '& + tr': {
            borderTopColor: '#3E505D',
          },
          '&:last-child': {
            borderBottomColor: '#3E505D',
          },
        },
      },
    },
    tableBodyCell: {
      base: {
        position: 'relative',
        height: '-webkit-fill-available',
      },
      variantMapping: {
        small: {
          padding: '5px 10px',
        },
        large: {
          padding: '8px 10px',
        },
      },
      fontSizeMapping: {
        small: {
          fontSize: '12px',
          lineHeight: '12px',
        },
        large: {
          fontSize: '14px',
          lineHeight: '14px',
        },
      },
      endCell: {
        borderBottom: 'solid 1px #333333',
      },
      summaryCell: {
        backgroundColor: '#F1F3F4',
      },
    },
  },
  taboggle: {
    base: {
      borderColor: '#767676',
      backgroundColor: '#E4E8EA',
      paddingBottom: '10px',
      pointerSize: 14.15,
    },
    contentWrapper: {
      base: {
        borderColor: '#767676',
        backgroundColor: '#E4E8EA',
      },
    },
    content: {
      base: {
        padding: '30px 20px 40px',
        width: '100%',
      },
    },
  },
  tabs: {
    tab: {
      varaintMapping: {
        light: {
          backgroundColor: '#E4E8EA',
          '&:hover, &:focus': {
            backgroundColor: '#FFFFFF',
          },
          '&:active': {
            backgroundColor: '#C9D0D5',
          },
        },
        dark: {
          backgroundColor: '#3E505D',
          borderRight: 'none',
          marginRight: '1px',
          '&:hover': {
            backgroundColor: '#4D6474',
          },
          '&:active': {
            backgroundColor: '#1D262C',
          },
        },
      },
      compact: {
        base: {
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        orientationMapping: {
          vertical: {
            base: {
              padding: '15px 15px',
              height: '50px',
              borderTop: '1px solid #D7D8D6',
              borderBottom: '1px solid #D7D8D6',
              '&:hover::after': {
                width: '1px',
                backgroundColor: '#FFFFFF',
              },
              '&:active::after': {
                width: '0px',
                backgroundColor: '#FFFFFF',
              },
            },
            selected: {
              backgroundColor: '#FFFFFF',
              '&::after': {
                backgroundColor: '#FFFFFF',
                width: '1px',
              },
              '&::before': {
                backgroundColor: '#DB0011',
                width: '3px',
              },
              '&:active': {
                backgroundColor: '#FFFFFF',
              },
            },
          },
          horizontal: {
            base: {
              padding: '10px 20px',
              height: '40px',
              borderLeft: '2px solid #FFFFFF',
              borderRight: '2px solid #FFFFFF',
            },
            fullpage: {
              padding: '10px 40px',
            },
            selected: {
              backgroundColor: '#FFFFFF',
              '&::after': {
                backgroundColor: '#FFFFFF',
                height: '1px',
              },
              '&::before': {
                backgroundColor: '#DB0011',
                height: '3px',
              },
              '&:active': {
                backgroundColor: '#FFFFFF',
              },
            },
          },
        },
      },
    },
    indicator: {
      backgroundColor: '#00847F',
      size: '10px',
      marginLeft: '5px',
    },
    panels: {
      vertical: {
        borderLeft: '1px solid #E4E8EA',
      },
      horizontal: {
        borderTop: '1px solid #D7D8D6',
      },
    },
    hBreakpoints: {
      extraLarge: {
        base: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        orientationMapping: {
          vertical: {
            base: {
              padding: '10px 20px',
              height: '44px',
              borderTop: '1px solid #D7D8D6',
              borderBottom: '1px solid #D7D8D6',
              '&:hover::after': {
                width: '1px',
                backgroundColor: '#FFFFFF',
              },
              '&:active::after': {
                width: '0px',
                backgroundColor: '#FFFFFF',
              },
            },
          },
          horizontal: {
            base: {
              padding: '10px 20px',
              height: '44px',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
            },
            fullpage: {
              padding: '10px 40px',
            },
          },
        },
      },
    },
  },
  textarea: {
    varaintMapping: {
      base: {
        border: 'solid 1px #767676',
        color: '#333333',
        marginBottom: '6px',
        cursor: 'auto',
        '&:hover:not(:disabled),&:focus,&:active:not(:disabled)': {
          border: 'solid 1px #2278CE',
        },
      },
      invalid: {
        border: 'solid 1px #A8000B',
        backgroundColor: '#F9F2F3',
        color: '#333333',
        marginBottom: '6px',
        outline: 'none',
        cursor: 'auto',
      },
    },
    compact: {
      sizeMapping: {
        large: {
          padding: '9px 10px 11px',
        },
        medium: {
          padding: '6px 10px 8px',
        },
        small: {
          padding: '2px 10px 4px',
        },
      },
      typographMapping: {
        large: {
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        medium: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
        small: {
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: 'normal',
          letterSpacing: 'normal',
        },
      },
    },
    hBreakpoints: {
      medium: {
        base: {
          padding: '9px 12px 11px',
          marginBottom: '8px',
        },
        font: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
      },
    },
  },
  inputs: {
    textInput: {
      base: {
        '&:hover:not(:disabled),&:focus,&:active:not(:disabled)': {
          borderColor: '#2278CE',
        },
        '::-ms-clear': {
          display: 'none',
        },
      },
      modeMapping: {
        light: {
          borderColor: '#767676',
          color: '#333333',
          backgroundColor: '#FFFFFF',
          '::placeholder': {
            color: '#333333',
            opacity: '1',
          },
          ':-ms-input-placeholder': {
            color: '#333333',
          },
          '::-ms-input-placeholder': {
            color: '#333333',
          },
        },
        dark: {
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
          backgroundColor: 'transparent',
          '::placeholder': {
            color: '#FFFFFF',
            opacity: '1',
          },
          ':-ms-input-placeholder': {
            color: '#FFFFFF',
          },
          '::-ms-input-placeholder': {
            color: '#FFFFFF',
          },
        },
      },
      stateMapping: {
        restricted: {
          borderWidth: '2px',
        },
        uneditable: {
          cursor: 'not-allowed',
          backgroundColor: '#F3F3F3',
        },
        locked: {
          borderWidth: '2px',
        },
        invalid: {
          '&:hover,&:focus,&:active': {
            borderColor: '#A8000B',
          },
          borderColor: '#A8000B',
          backgroundColor: '#F9F2F3',
        },
      },
      prefix: {
        base: {
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '10px',
          paddingRight: '10px',
          border: '1px solid #767676',
          borderRightStyle: 'none',
          whiteSpace: 'nowrap',
        },
        light: {
          color: '#333333',
        },
        dark: {
          borderColor: '#FFFFFF',
          color: '#FFFFFF',
        },
      },
      compact: {
        typographMapping: {
          base: {
            small: {
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
            medium: {
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
            large: {
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
          },
          prefix: {
            small: {
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
            medium: {
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
            large: {
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: 'normal',
              letterSpacing: 'normal',
            },
          },
        },
        sizeMapping: {
          small: {
            height: '22px',
            padding: '2px 10px 4px',
          },
          medium: {
            height: '30px',
            padding: '6px 10px 8px',
          },
          large: {
            height: '40px',
            padding: '9px 10px 11px',
          },
        },
        iconMapping: {
          small: {
            padding: '4px 10px',
          },
          medium: {
            padding: '8px 10px',
          },
          large: {
            padding: '11px 10px',
          },
        },
        iconSizeMapping: {
          small: 14,
          medium: 14,
          large: 18,
        },
      },
      hBreakpoints: {
        base: {
          height: '44px',
          padding: '9px 12px 11px',
        },
        font: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        prefixFont: {
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 'normal',
        },
        iconMapping: {
          base: {
            padding: '13px',
          },
          size: 18,
        },
      },
    },
  },
  tooltip: {
    box: {
      backgroundColor: '#FFFFFF',
      borderWidth: '1px',
      borderRadius: 0,
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
    },
    compact: {
      box: {
        borderColor: '#333333',
        fontSize: '12px',
        padding: '11px 15px 13px',
      },
      variantMap: {
        default: {
          backgroundColor: '#FFFFFF',
          borderColor: '#333333',
          color: '#333333',
        },
        error: {
          backgroundColor: '#F9F2F3',
          borderColor: '#A8000B',
          color: '#333333',
        },
        warning: {
          backgroundColor: '#FFF8EA',
          borderColor: '#FFBB33',
          color: '#333333',
        },
        success: {
          backgroundColor: '#E5F2F2',
          borderColor: '#00847F',
          color: '#333333',
        },
        info: {
          backgroundColor: '#EBEFF4',
          borderColor: '#305A85',
          color: '#333333',
        },
      },
    },
    hBreakpoints: {
      box: {
        borderColor: '#D7D8D6',
        fontSize: '14px',
        padding: '8px 12px 12px',
      },
      variantMap: {
        default: {
          backgroundColor: '#FFFFFF',
          borderColor: '#D7D8D6',
          color: '#333333',
        },
        error: {
          backgroundColor: '#F9F2F3',
          borderColor: '#A8000B',
          color: '#333333',
        },
        warning: {
          backgroundColor: '#FFF8EA',
          borderColor: '#FFBB33',
          color: '#333333',
        },
        success: {
          backgroundColor: '#E5F2F2',
          borderColor: '#00847F',
          color: '#333333',
        },
        info: {
          backgroundColor: '#EBEFF4',
          borderColor: '#305A85',
          color: '#333333',
        },
      },
    },
  },
};
